var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1462 4471 c-1155 -357 -1109 -340 -1133 -421 -7 -24 -9 -265 -6 -745 5 -785 4 -779 76 -1047 139 -522 478 -991 930 -1286 46 -30 329 -188 630 -351 526 -284 548 -295 601 -295 53 0 73 9 570 278 607 328 640 347 778 450 400 301 693 739 817 1221 68 265 68 268 72 1035 3 382 2 709 -2 726 -3 17 -20 48 -38 68 -32 38 -34 38 -1102 367 -588 181 -1083 329 -1100 328 -16 0 -508 -148 -1093 -328z m2063 -295 l950 -292 3 -560 c2 -358 -1 -599 -8 -669 -58 -574 -369 -1092 -846 -1410 -46 -30 -304 -174 -573 -320 l-490 -264 -483 260 c-266 143 -532 293 -593 334 -470 314 -778 830 -835 1402 -7 68 -10 313 -8 667 l3 559 950 293 c523 161 957 293 965 293 8 0 443 -131 965 -293z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420 3985 c-175 -38 -346 -172 -428 -335 -95 -191 -95 -389 0 -580 84 -167 251 -296 434 -335 450 -95 854 309 759 759 -73 343 -418 565 -765 491z m290 -346 c68 -36 99 -68 138 -143 22 -43 26 -64 27 -136 0 -79 -3 -90 -36 -150 -154 -280 -571 -191 -597 127 -20 250 245 421 468 302z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1963 2545 c-175 -48 -317 -195 -353 -369 -7 -34 -10 -157 -8 -344 3 -275 4 -292 24 -318 39 -53 71 -69 134 -69 63 0 95 16 134 69 20 26 21 44 26 326 5 282 6 300 26 326 11 15 33 37 48 48 27 21 38 21 566 21 528 0 539 0 566 -21 15 -11 37 -33 48 -48 20 -26 21 -44 26 -326 5 -282 6 -300 26 -326 39 -53 71 -69 134 -69 63 0 95 16 134 69 20 26 21 43 24 312 2 170 -1 308 -8 341 -33 180 -175 331 -355 378 -84 21 -1112 21 -1192 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.f31e9a56b5f1485aadf77ab9d5ba326f.svg";
export { ForwardRef as ReactComponent };